/**
 * Menvora — evita TypeError de Capturly GA4 bridge:
 * capturly.com/js/ga4/external.js hace JSON.stringify(dataLayer[i])
 * y falla si el entry tiene HTML*Element (React fiber circular).
 *
 * Cargar ANTES de Capturly. No cambia tracking: solo omite Nodes/funciones.
 */
(function () {
  if (window.__menvoraDatalayerSanitize) return;
  window.__menvoraDatalayerSanitize = true;

  function isDom(v) {
    if (!v || typeof v !== 'object') return false;
    if (typeof Node !== 'undefined' && v instanceof Node) return true;
    if (typeof Element !== 'undefined' && v instanceof Element) return true;
    return v.nodeType === 1 || v.nodeType === 3;
  }

  function stripDomKeys(obj) {
    if (!obj || typeof obj !== 'object' || isDom(obj)) return 0;
    var removed = 0;
    try {
      Object.keys(obj).forEach(function (k) {
        var v = obj[k];
        if (isDom(v) || typeof v === 'function') {
          try {
            delete obj[k];
            removed += 1;
          } catch (e) {}
        }
      });
    } catch (e) {}
    return removed;
  }

  function scrubDataLayer() {
    var dl = window.dataLayer;
    if (!dl || !dl.length) return 0;
    var total = 0;
    for (var i = 0; i < dl.length; i++) {
      total += stripDomKeys(dl[i]);
    }
    return total;
  }

  var nativeStringify = JSON.stringify.bind(JSON);
  JSON.stringify = function (value, replacer, space) {
    var userFn = typeof replacer === 'function' ? replacer : null;
    if (Array.isArray(replacer)) {
      return nativeStringify(value, replacer, space);
    }

    function baseReplacer(key, val) {
      if (isDom(val) || typeof val === 'function') return undefined;
      if (userFn) return userFn.call(this, key, val);
      return val;
    }

    try {
      return nativeStringify(value, baseReplacer, space);
    } catch (e) {
      var msg = String((e && e.message) || e || '');
      if (!/circular/i.test(msg)) throw e;
      var seen = typeof WeakSet !== 'undefined' ? new WeakSet() : null;
      try {
        return nativeStringify(
          value,
          function (key, val) {
            if (isDom(val) || typeof val === 'function') return undefined;
            if (val && typeof val === 'object' && seen) {
              if (seen.has(val)) return undefined;
              seen.add(val);
            }
            if (userFn) return userFn.call(this, key, val);
            return val;
          },
          space
        );
      } catch (e2) {
        return '{}';
      }
    }
  };

  window.dataLayer = window.dataLayer || [];
  scrubDataLayer();

  var origPush = window.dataLayer.push;
  window.dataLayer.push = function () {
    var args = [];
    for (var i = 0; i < arguments.length; i++) {
      var item = arguments[i];
      if (item && typeof item === 'object' && !isDom(item)) {
        stripDomKeys(item);
      }
      args.push(item);
    }
    return origPush.apply(window.dataLayer, args);
  };

  // Capturly puede escanear tras requests GA; re-scrub ligero
  setInterval(scrubDataLayer, 2000);
})();
